export var AuthorizationGroup;
(function (AuthorizationGroup) {
    AuthorizationGroup[AuthorizationGroup["Global"] = 1] = "Global";
    AuthorizationGroup[AuthorizationGroup["Organization"] = 2] = "Organization";
    AuthorizationGroup[AuthorizationGroup["Event"] = 3] = "Event";
})(AuthorizationGroup || (AuthorizationGroup = {}));
export var GlobalRole;
(function (GlobalRole) {
    GlobalRole[GlobalRole["Admin"] = 16] = "Admin";
    GlobalRole[GlobalRole["Anyone"] = 12] = "Anyone";
    GlobalRole[GlobalRole["User"] = 8] = "User";
    GlobalRole[GlobalRole["Self"] = 1] = "Self";
    GlobalRole[GlobalRole["Nobody"] = -1] = "Nobody";
})(GlobalRole || (GlobalRole = {}));
export var OrganizationRole;
(function (OrganizationRole) {
    OrganizationRole[OrganizationRole["Owner"] = 16] = "Owner";
    OrganizationRole[OrganizationRole["Manager"] = 12] = "Manager";
    OrganizationRole[OrganizationRole["Staff"] = 8] = "Staff";
    OrganizationRole[OrganizationRole["Pending"] = 0] = "Pending";
    OrganizationRole[OrganizationRole["Blocked"] = -1] = "Blocked";
})(OrganizationRole || (OrganizationRole = {}));
export var EventRole;
(function (EventRole) {
    EventRole[EventRole["Organizer"] = 16] = "Organizer";
    EventRole[EventRole["Judge"] = 12] = "Judge";
    EventRole[EventRole["JudgePending"] = 11] = "JudgePending";
    EventRole[EventRole["JudgeInactive"] = 10] = "JudgeInactive";
    EventRole[EventRole["Pending"] = 0] = "Pending";
    EventRole[EventRole["Blocked"] = -1] = "Blocked";
})(EventRole || (EventRole = {}));



//////////////////
// WEBPACK FOOTER
// ./src/imports/server-main/authorization.enum.ts
// module id = 121
// module chunks = 0